// @flow

import React, { Component, type ComponentType } from 'react';
import { connect } from 'react-redux';
import {
  getPdbIds,
  fetchPdbItems,
  hydrateComparison as hydrateComparisonAction,
} from '../../../store/pdbComparison';
import { setUiSetting, getUiSettingOrDefault } from '../../../store/uiStore';

type DispatchProps = {|
  fetch: Function,
  loadingComplete: Function,
  hydrateComparison: Function,
|};

type StateProps = {|
  pdbIds: Array<string>,
  isLoading: boolean,
|};

type Props = {|
  ...DispatchProps,
  ...StateProps,
|};

const PDB_COMPARE_LOADING = 'pdb-compare-loading';

const hasFlag = (flag: string) => {
  if (process.env[`LISTO_${flag}`] !== 'true' || process.env[`STORYBOOK_${flag}`] !== 'true') {
    return true;
  }
  return false;
};

const withPdbIdsFromStorage = (WrappedComponent: ComponentType<*>) => {
  class PdbIdsFromStorage extends Component<Props> {
    componentDidMount = async () => {
      const {
        fetch,
        loadingComplete,
        hydrateComparison,
      } = this.props;

      hydrateComparison();
      await fetch();
      loadingComplete();
    }

    render() {
      const {
        pdbIds,
        isLoading,
      } = this.props;

      if (!hasFlag('FLAG_PDB_CTA_COMPARE')) {
        return null;
      }

      if (isLoading) {
        return null;
      }

      return (
        <WrappedComponent
          pdbIds={pdbIds}
          {...this.props}
        />
      );
    }
  }

  const mapStateToProps = (state): StateProps => ({
    pdbIds: getPdbIds(state),
    isLoading: getUiSettingOrDefault(state, PDB_COMPARE_LOADING, true),
  });

  const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    fetch: () => dispatch(fetchPdbItems()),
    hydrateComparison: () => dispatch(hydrateComparisonAction()),
    loadingComplete: () => dispatch(setUiSetting(PDB_COMPARE_LOADING, false)),
  });

  return connect<Props, any, StateProps, DispatchProps, any, any>(
    mapStateToProps,
    mapDispatchToProps,
  )(PdbIdsFromStorage);
};

export default withPdbIdsFromStorage;
